import { render } from "./accordion.vue?vue&type=template&id=102ce1bb&scoped=true&ts=true"
import script from "./accordion.vue?vue&type=script&lang=ts"
export * from "./accordion.vue?vue&type=script&lang=ts"

import "./accordion.vue?vue&type=style&index=0&id=102ce1bb&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-102ce1bb"]])

export default __exports__